import { type RouteRecordRaw } from 'vue-router'
import { getRandomInt } from '@vcfinder/ui-kit'
export const quizzSteps = {
    0: 'step0',
    1: 'step1',
    2: 'step2',
    3: 'step3'
}
export enum routeNames {
  bfeeds = 'b-feeds',
  survey = 'quizz',
  result = 'result',
  home = 'home',
  reveal = 'reveal',
  uikit = 'uikit',
  algo = 'algo',
}

export const routesRecord = (locale: string): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = [
    {
      path: '/:locale/',
      name: `${routeNames.home}`,
      component: () => import('../views/1_Home.vue'),
      beforeEnter: (to, _, next) => {
        const kiosk = import.meta.env.VITE_KIOSK ? import.meta.env.VITE_KIOSK === "true" : !(to.query.kiosk || to.query.kiosk === 'false')
        if (kiosk) {
          next()
        } else {
          // A_B Testing
          const isAllowed = to.query?.gtm === 'false' || to?.query?.gtm === undefined ? false : true
          const min = 0
          const max = 100
          const defaultTest = '0'
          const secondSample  = '1'
          const half = Math.floor((max - min) / 2)
          const random = getRandomInt(min, max)

          let  test = defaultTest
          let retailler = to.query?.retailler === undefined ? '' : `&retailler=${to.query?.retailler}`
          let uri = `/${to.params.locale}/${routeNames.survey}/${test}?kiosk=false&gtm=${isAllowed}${retailler}`
          const restriction_LOCALE = ['en-us']
          if (restriction_LOCALE.some(locale => locale.toLowerCase() === `${to.params?.locale}`.toLowerCase())) {
            test = to.query?.ab === undefined ? random >= half ? defaultTest : secondSample : `${to.query?.ab}`
            uri = `/${to.params.locale}/${routeNames.survey}/${test}?kiosk=false&gtm=${isAllowed}${retailler}`
            // uri = `${uri}&ab=${test}` // AB test disable for now
            // console.log('AB', test)
          }
          next(uri)
        }
      },
      props: true,
    },
    {
      path: `/:locale/${routeNames.survey}/0`,
      name: `${quizzSteps[0]}`,
      component: () => import('../views/2_Survey/2_0_2_2_Input.vue'),
      props: { step: '0', locale: locale },
    },
    {
      path: `/:locale/${routeNames.survey}/1`,
      name: `${quizzSteps[1]}`,
      component: () => import('../views/2_Survey/2_1_2_3_Slider.vue'),
      props: { step: '1', locale: locale }
    },
    {
      path: `/:locale/${routeNames.survey}/2`,
      name: `${quizzSteps[2]}`,
      component: () => import('../views/2_Survey/2_0_2_2_Input.vue'),
      props: { step: '2' }
    },
    {
      path: `/:locale/${routeNames.survey}/3`,
      name: `${quizzSteps[3]}`,
      component: () => import('../views/2_Survey/2_1_2_3_Slider.vue'),
      props: { step: '3' }
    },
    {
      path: `/:locale/${routeNames.reveal}/:ean`,
      name: `${routeNames.reveal}`,
      component: () => import('../views/3_VideoReveal.vue'),
      props: true
    },
    {
      path: `/:locale/${routeNames.result}/:ean`,
      name: `${routeNames.result}`,
      component: () => import('../views/4_Result.vue'),
      props: true
    },
    {
      path: `/:locale/${routeNames.algo}`,
      name: `${routeNames.algo}`,
      component: () => import('../views/5_Algo.vue'),

    },
    {
      path: `/:locale/${routeNames.bfeeds}`,
      name: `${routeNames.bfeeds}`,
      component: () => import('../views/bfeeds-external/Home.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: () => `/${locale}`
    }
  ]
  return routes
}
export default routesRecord
